/* src/app/master-data/suppliers/supplierSite/list-supplierSite/list-supplierSite.component.css */
/*# sourceMappingURL=list-supplierSite.component-TH2WIBTE.css.map */
